import type { VspId } from '@core/core/types'
import { isFilterType } from '@core/core/types'
import { hasKeysExact } from 'common/helpers'

import type { FilterForm } from './types'

export const isFilterForm = (candidate: unknown): candidate is FilterForm =>
  typeof candidate === 'object' &&
  candidate != null &&
  hasKeysExact(candidate, 'searchQuery', 'fieldId', 'filter') &&
  (candidate.searchQuery === null || typeof candidate.searchQuery === 'string') &&
  (candidate.fieldId === null || typeof candidate.fieldId === 'string') &&
  isFilterType(candidate.filter)

export const isFilterFormWithVsp = (
  candidate: unknown,
): candidate is FilterForm & { vspId?: VspId } =>
  typeof candidate === 'object' &&
  candidate != null &&
  hasKeysExact(candidate, 'searchQuery', 'fieldId', 'filter', 'vspId') &&
  (candidate.searchQuery === null || typeof candidate.searchQuery === 'string') &&
  (candidate.fieldId === null || typeof candidate.fieldId === 'string') &&
  (candidate.vspId === undefined || typeof candidate.vspId === 'string') &&
  isFilterType(candidate.filter)

export const isArrayOfIds = <IdType>(candidate: unknown): candidate is IdType[] =>
  Array.isArray(candidate) && candidate.every(item => typeof item === 'string')

export const isValidInteger = (value: unknown): value is string =>
  typeof value === 'string' && !isNaN(parseInt(value, 10))
